import axios from 'axios';

const UNSPLASH_API_KEY = import.meta.env.VITE_UNSPLASH_ACCESS_KEY;
const UNSPLASH_API_URL = 'https://api.unsplash.com/search/photos';

interface ImageSearchRequest {
  query: string;
  count: number;
}

export async function fetchImages(req: ImageSearchRequest) {
  try {
    const response = await axios.get(UNSPLASH_API_URL, {
      params: {
        query: req.query,
        per_page: req.count,
        order_by: 'relevant',
      },
      headers: {
        Authorization: `Client-ID ${UNSPLASH_API_KEY}`,
      },
    });

    return response.data.results.map((photo: any) => ({
      id: photo.id,
      url: photo.urls.regular,
      thumbnailUrl: photo.urls.thumb,
      description: photo.description || photo.alt_description,
      photographer: photo.user.name,
    }));
  } catch (error) {
    console.error('Error fetching images:', error);
    return getDefaultImages();
  }
}

export async function fetchImageForScene(sceneDescription: string) {
  try {
    const keywords = extractKeywords(sceneDescription);
    const response = await axios.get(UNSPLASH_API_URL, {
      params: {
        query: keywords,
        per_page: 1,
        order_by: 'relevant',
      },
      headers: {
        Authorization: `Client-ID ${UNSPLASH_API_KEY}`,
      },
    });

    if (response.data.results.length > 0) {
      const photo = response.data.results[0];
      return {
        id: photo.id,
        url: photo.urls.regular,
        thumbnailUrl: photo.urls.thumb,
        description: photo.description || photo.alt_description,
      };
    }
    return getDefaultImage();
  } catch (error) {
    console.error('Error fetching image for scene:', error);
    return getDefaultImage();
  }
}

function extractKeywords(text: string): string {
  const words = text.split(' ').slice(0, 3).join(' ');
  return words || 'abstract';
}

function getDefaultImage() {
  return {
    id: 'default',
    url: 'https://images.unsplash.com/photo-1557672172-298e090d0f80?w=1200&h=675&fit=crop',
    thumbnailUrl: 'https://images.unsplash.com/photo-1557672172-298e090d0f80?w=200&h=200&fit=crop',
    description: 'صورة افتراضية',
  };
}

function getDefaultImages() {
  return [
    {
      id: '1',
      url: 'https://images.unsplash.com/photo-1557672172-298e090d0f80?w=1200&h=675&fit=crop',
      thumbnailUrl: 'https://images.unsplash.com/photo-1557672172-298e090d0f80?w=200&h=200&fit=crop',
      description: 'صورة افتراضية 1',
    },
    {
      id: '2',
      url: 'https://images.unsplash.com/photo-1611339555312-e607c25352ba?w=1200&h=675&fit=crop',
      thumbnailUrl: 'https://images.unsplash.com/photo-1611339555312-e607c25352ba?w=200&h=200&fit=crop',
      description: 'صورة افتراضية 2',
    },
  ];
}
